import { Component, Input, Output } from '@angular/core';
import { ToastyService } from 'ng2-toasty';
import { EventEmitter } from '@angular/core';
import * as EmailValidator from 'email-validator';
import { MultipleEmail } from '../../../models/agents/multiple-email';

@Component({
  selector: 'app-multiple-email',
  templateUrl: './multiple-email.component.html',
  styleUrls: ['./multiple-email.component.scss']
})

export class MultipleEmailComponent {

  @Input() readOnly = false;
  @Input() placeholder = ' ';
  @Input() secondPlaceholder = ' ';
  @Input() emails: Array<MultipleEmail> = [];
  @Output() returnEmail = new EventEmitter();

  constructor(
    protected toastyService: ToastyService
  ) {
    this.emails = new Array<MultipleEmail>();
  }

  onAddEmail(event: any): void {
    setTimeout(() => {
      if (!EmailValidator.validate(event.value)) {
        this.emails = this.emails.filter(email => email.value !== event.value);
      }

      this.returnEmail.emit(
        this.emails
          .map(email => email.value)
          .join(',')
      );
    }, 100);
  }

  onDeleteEmail(event: string): void {
    setTimeout(() => {
      this.returnEmail.emit(
        this.emails
          .map(em => em.value)
          .join(',')
      );
    }, 100);
  }

  loadingEmail(emails: Array<MultipleEmail>) {
    this.emails = emails;
  }
}
